import Drawer from '@/component/Drawer'
import useStatePopup from '@/hook/useStatePopup'
import { PopupSelector, PopUpStore } from '@/store/PopupStore'
import React from 'react'
import { useTranslation } from 'react-i18next'
import TradeRecordMain from './TradeRecordMain'

const TradeRecordPopup: React.FC<PropType> = () => {
  const { t } = useTranslation('wallet')
  const { visible } = useStatePopup(PopupSelector.billingPopup)

  const handleClose = () => {
    PopUpStore.setBillingPopup({
      visible: false
    })
  }

  return (
    <Drawer
      visible={visible}
      zIndex={903}
      onClose={handleClose}
      lockScroll={true}
      destroyOnClose
      className="bg-primary-light"
      title={t('modalTitle.billing')}
    >
      <div className="h-full">
        <TradeRecordMain />
      </div>
    </Drawer>
  )
}

interface PropType {}

export default TradeRecordPopup
